import { get, map, mapValues } from 'lodash'
import { getReq } from '../../utils/request'
import { formatDateWithTime } from '../../utils/helper'
import { IPriceOffersPayload, PriceOfferOriginalItem, PriceOfferTableItem } from '../../reducers/priceOffers/actions'

const fetchPriceOffersList = async (
	page: number = 1,
	limit: number | null = 20,
	queryParams: any = {},
	deleted: boolean = false
) => {
	const queries = {
		limit,
		page,
		...queryParams,
		...(deleted ? { deleted: true } : {})
	}

	const normalizeQueryParams = mapValues(queries, (query) => query || undefined)
	const { data } = await getReq('/api/admin/price-offers', normalizeQueryParams)

	const originalData: PriceOfferOriginalItem[] = get(data, 'priceOffers', [])
	const tableData: PriceOfferTableItem[] = map(originalData, (column) => ({
		key: column.id,
		id: column.id,
		address: column.address,
		organizationName: column.organizationName,
		status: column.status,
		createdAt: formatDateWithTime(column.createdAt),
		updatedAt: formatDateWithTime(column.updatedAt),
		deletedAt: column.deletedAt ? formatDateWithTime(column.deletedAt) : null,
		deletedBy: column.deletedBy ?? null
	}))

	return {
		tableData,
		originalData,
		pagination: get(data, 'context')
	} as IPriceOffersPayload
}

export default fetchPriceOffersList
